export default "__VITE_ASSET__BqgF4ZHs__"